module.exports = __webpack_public_path__ + "static/media/error.63a8039f.mp3";